var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0464 4.14229V2.54748C10.0464 2.30588 10.0031 2.0669 9.9193 1.84566C9.83551 1.62442 9.71301 1.42573 9.55955 1.26214C9.40609 1.09854 9.225 0.973614 9.02774 0.895241C8.83048 0.816867 8.62133 0.786756 8.41351 0.806809L2.38259 1.38849C2.00569 1.42486 1.65436 1.624 1.39827 1.94642C1.14217 2.26884 1.00002 2.691 1 3.12916V13.8893C1.00002 14.3275 1.14217 14.7497 1.39827 15.0721C1.65436 15.3945 2.00569 15.5937 2.38259 15.63L8.41351 16.2126C8.62139 16.2326 8.83061 16.2025 9.02792 16.1241C9.22523 16.0456 9.40635 15.9206 9.55982 15.7569C9.7133 15.5933 9.83578 15.3945 9.91953 15.1731C10.0033 14.9518 10.0465 14.7127 10.0464 14.471V12.8762M9.29252 8.50925H16.0773H9.29252ZM16.0773 8.50925L13.5647 5.01569L16.0773 8.50925ZM16.0773 8.50925L13.5647 12.0028L16.0773 8.50925Z",
    stroke: "#292929",
    strokeWidth: 1.50773,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector9);
export default __webpack_public_path__ + "static/media/Vector9.d4f31e3d3484dbfa6e2a04d52cea66d4.svg";
export { ForwardRef as ReactComponent };